import fileUtils from '../../../../../util/fileUtils';

export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg'];
export const OFFICE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx'];

export const formatFileSize = (sizeInBytes = 0) => fileUtils.formatFileSize(sizeInBytes);

export const formatDate = (dateValue) => {
  if (!dateValue) return '-';
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString();
};

export const getExtension = (filename = '') => filename.split('.').pop()?.toLowerCase();

export const extensionTag = (filename = '') => getExtension(filename)?.toUpperCase() || 'FILE';

export const getDocumentPreviewKind = (document = {}) => {
  const extension = getExtension(document.filename);
  const mimeType = document.content_type || '';

  if (IMAGE_EXTENSIONS.includes(extension) || mimeType.startsWith('image/')) return 'image';
  if (extension === 'pdf' || mimeType === 'application/pdf') return 'pdf';
  if (OFFICE_EXTENSIONS.includes(extension)) return 'file';

  return 'file';
};
